<template>
	<v-container fill-height fluid class="pa-0">
		<NovoAtendimento :registroPessoa="pessoa" :mostrar="abrirNovoAtendimento" @fecharAtendimento="fecharNovoAtendimento()"/>
		<Editar @fecharEdicaoPessoa="abrirEdicao = false" :dados="this.pessoa" :mostrar="abrirEdicao"/>
		<Excluir @pessoaExcluida="atualizarExclusao($event)" :mostrar="abrirExclusaoPessoa" :pessoa="this.pessoa" @fecharExcluir="fechar()"/>
		<Novo @fecharNovaPessoa="abrirNovoCadastro = false" @pessoaCadastrada="atualizarLista($event)" :mostrar="abrirNovoCadastro" />
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
					<v-card-title>
						<v-row>
							<v-col cols="4" offset="7">
						<v-text-field dense
									v-model="search"
									append-icon="mdi-magnify"
									label="Pesquisa"
									single-line
									hide-details
								></v-text-field>
							
							</v-col>
							<v-col cols="1">
								<v-btn class="mx-2" @click="cadastrarNovaPessoa" color="primary" small>Novo</v-btn>
							</v-col>
						</v-row>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 170"
						locale="pt-BR" dense fixed-header class="table-item" :search="search" :items="pessoas" :headers="fields" :items-per-page="15">
							<template v-slot:item.signo="{ item }">
								{{ retornaSigno(item.dataNascimentoObj) }}
							</template>
							<template v-slot:item.desafio="{ item }">
								{{ retornaDesafio(item.dataNascimentoObj) }}
							</template>
							<template v-slot:item.mestre="{ item }">
								{{ retornaMestre(item.dataNascimentoObj) }}
							</template>
							<template v-slot:item.action="{ item }">
								<v-btn icon class="mx-1" color="primary" @click="gerarNovoAtendimento(item)">
									<v-icon>mdi-bottle-tonic-plus</v-icon>
								</v-btn>
								<v-btn icon class="mx-1" color="primary" @click="editar(item)">
									<v-icon>mdi-lead-pencil</v-icon>
								</v-btn>
								<v-btn icon color="primary"  @click="excluir(item)">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
						</v-data-table>
						<v-row>
                            <v-col cols=12>
                                <v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
                                </v-pagination>
                            </v-col>
                        </v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, showError } from "@/config/global"
	import axios from 'axios'
	import Editar from '@/components/atendimento/pessoas/Editar'
	import Excluir from '@/components/atendimento/pessoas/Excluir'
	import Novo from '@/components/atendimento/pessoas/Novo'
	import metodos from '@/mixins/metodos.js'
	import NovoAtendimento from '@/components/atendimento/fichas/Novo'

	export default{
		mixins:[metodos],
		components:{Editar, Excluir, Novo, NovoAtendimento},
		computed:{

		},
		data(){
			return {
				pagina: 1,
                totalPaginas: 1,
                itensPorPagina: 8,
				search: '',
				abrirEdicao: false,
				abrirNovoCadastro: false,
				abrirExclusaoPessoa: false,
				abrirNovoAtendimento: false,
				pessoas: [],
				pessoa: {},
				fields: [
					{value: 'id', text: 'Código', align: 'center'},
					{value: 'nome', text: 'Nome', align: 'center'},
					// {value: 'data_nascimento', text: 'Data Nascimento', align: 'center'},
					{value: 'email', text: 'Email', align: 'center'},
					{value: 'telefone', text: 'Telefone', align: 'center'},
					// {value: 'sexo', text: 'Sexo', align: 'center'},
					{value: 'signo', text: 'Signo', align: 'center'},
					{value: 'mestre', text: 'Mestre', align: 'center'},
					{value: 'desafio', text: 'Desafio', align: 'center'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
                ],
                loading: false

			}
		},
		methods:{
			buscaPessoas(){
				this.loading = true
				const url = `${baseApiUrl}/Atendimentos/Pessoas/read.php`

				axios.get(url)
						.then(res => {
							this.pessoas = res.data.map(p =>{
								return {
									...p,
									dataNascimentoObj : this.converterData(p.data_nascimento)
								}
							})

							this.totalPaginas = Math.ceil(this.pessoas.length / this.itensPorPagina)
							this.loading = false
						})
						.catch({showError})
            },

            cadastrarNovaPessoa(){
				this.pessoa = {},
				this.abrirNovoCadastro = true
			},

			editar(pessoa){
				
				this.pessoa = pessoa
				this.pessoa.signo = this.retornaSigno(this.pessoa.dataNascimentoObj)
				this.pessoa.desafio = this.retornaDesafio(this.pessoa.dataNascimentoObj)
				this.pessoa.mestre = this.retornaMestre(this.pessoa.dataNascimentoObj)
				this.abrirEdicao = true
			},

			atualizarLista(pessoa){
				this.pessoas.push(pessoa)
			},

			excluir(pessoa){
				this.pessoa = pessoa
				this.abrirExclusaoPessoa = true
			},

			fechar(){
				this.abrirExclusaoPessoa = false
				this.pessoa = {}
			},
			atualizarExclusao(pessoa){
				this.abrirExclusaoPessoa = false
				let idx = this.pessoas.findIndex((v) => {
					return v.id == pessoa.id
				})

				this.pessoas.splice(idx)

			},

			async gerarNovoAtendimento(pessoa){
				this.loading = true
				let atendimentoAberto = await this.existeAtendimentoAberto(pessoa.id)
				if(!atendimentoAberto){
					this.pessoa = pessoa
					this.abrirNovoAtendimento = true
				}else{
					showError("Já existe atendimento em aberto para essa pessoa!")
				}
				this.loading = false
			},

			async existeAtendimentoAberto(id){
				const url = `${baseApiUrl}/Atendimentos/Pessoas/buscaAtendimentos.php`
				let resultado = null
				await axios.post(url, {id: id})
					.then(res => {
						resultado = res.data.resultado
					})
					.catch({showError})
				
				return resultado
			},

			fecharNovoAtendimento(){
				this.abrirNovoAtendimento = false
			}

			

		},

		created(){
			this.buscaPessoas()
		}
	}
</script>

<style scoped>

</style>